import { useToast } from '@/components/ui/toast'

const { toast } = useToast()

export const genericErrorToast = () => {
  toast({
    title: 'Fehler',
    description: 'Leider ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    variant: 'destructive'
  })
}

export const genericSuccessToast = () => {
  toast({
    title: 'Erfolg',
    description: 'Die Aktion wurde erfolgreich ausgeführt.',
    variant: 'success'
  })
}

export const saveSuccessToast = () => {
  toast({
    title: 'Erfolg',
    description: 'Die Änderungen wurden erfolgreich gespeichert.',
    variant: 'success'
  })
}

export const deleteSuccessToast = () => {
  toast({
    title: 'Erfolg',
    description: 'Der Eintrag wurde erfolgreich gelöscht.',
    variant: 'success'
  })
}

export const createSuccessToast = () => {
  toast({
    title: 'Erfolg',
    description: 'Der Eintrag wurde erfolgreich erstellt.',
    variant: 'success'
  })
}
